import * as Yup from "yup";

export const validationSchema = Yup.object({
  event_images: Yup.string().required("Event image is required!"),
  title: Yup.string().required("Title is required!"),
  description: Yup.string().required("Description is required!"),
  location: Yup.string().required("Location is required!"),
  start_date: Yup.date().nullable().required("Start date is required!"),
  end_date: Yup.date().nullable(),
  start_time: Yup.string().required("Start time is required!"),
  end_time: Yup.string().nullable(),
  is_active: Yup.string().required("Status is required!"),
  template_id: Yup.number().when("is_online_booking_available", {
    is: 1,
    then: (schema) => schema.required("Template is required!"),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
  // event_registration_link: Yup.array().of(
  //   Yup.object().shape({
  //     title: Yup.string().required("Title is required!"),
  //     link: Yup.string().required("Link is required!"),
  //     button_title: Yup.string().required("Button Title is required!"),
  //   })
  // ),
});
